export default __webpack_public_path__ + "static/media/SENAIT_FR_EPILOGFIN2.092cd53f.mp3";